export const frontendUrl = (slug) => {
  const base = process.env.REACT_APP_FRONTEND_URL;
  if (base) {
    return `${base.replace(/\/$/, "")}/pages/${slug}`;
  }
  const apiBase = process.env.REACT_APP_BASE_URL || "";
  const derived = apiBase.replace(/^https?:\/\/api\./, "https://").replace(/\/$/, "");
  if (derived && derived !== apiBase.replace(/\/$/, "")) {
    return `${derived}/pages/${slug}`;
  }
  return `https://app.baring.digital/pages/${slug}`;
};
